import React, { useEffect, useContext, useState, ReactNode } from "react";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PersonIcon from "@mui/icons-material/Person";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { IconWithToolTip } from "../common";
import CategoryIcon from "@mui/icons-material/Category";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import {
  ROLE_USER_ADMIN,
  ROLE_USER_SUPERADMIN,
  ROLE_USER_MANAGER,
  UserData,
  FeedbackResponse,
  IFilter,
} from "../../model";

import {
  Autocomplete,
  Button,
  Chip,
  Divider,
  Drawer,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { appLogger, Http } from "../../../src/utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { Box, Rating, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import RatingChart from "./rating";
import CategoryChart from "./category";
import Reports from "./reports";
import { getDateString, getDateTime, getDateTimeRange } from "../../utils/data";
import { useLocation, useNavigate } from "react-router-dom";
import DashBugReportchart from "../dashboard/BugReportChart";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import ProductVersionDropdown from "../common/ProductVersionDropdown";
import EmailIcon from "@mui/icons-material/Email";
import NoProductMessage from "../../utils/common/NoProductMessage";
import { enableInsights } from "../../utils/config";
import InsightsIcon from "@mui/icons-material/Insights";

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface FilterProps {
  pageType: string;
  stateValue: {
    state: {
      keyWordType: string;
      insight: number;
      keyName: string;
    };
  };
  snackbarShowMessage: (errMsg: string, status: string, num?: number) => void;
}

function Filter(props: FilterProps) {
  appLogger.info({
    infoObj: {
      method: "Filter",
      component: "feedback",
      fileName: "filter.tsx",
      props: props,
    },
  });

  const { pageType, stateValue } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const [product, setProduct] = useState("");
  const [productResponse, setProductResponse] = useState([] as any);
  const [selectedProVerData, setselectedProVerData] = React.useState([] as any);
  const [version, setVersion] = useState("");
  const [filterResponse, setFilterResponse] = useState([] as any);
  const [selectedFilter, setSelectedFilter] = useState<{
    advanceFilters?: IFilter[];
    filters: IFilter[];
    name?: string;
    id?: string;
  }>({ filters: [] });
  const [appliedFilter, setAppliedFilter] = useState<any>({});
  // const [filter, setFilter] = useState("");
  const [search, setSearch] = React.useState("");
  const [searchKeyword, setSearchKeyword] = React.useState("");
  const [userData, setUserData] = React.useState<UserData[]>([]);
  const [filterUrlData, setFilterUrlData] = React.useState("");
  const [addFilterUrlData, setAddFilterUrlData] = React.useState("");
  const [filteredTotal, setFilteredTotal] = useState("NA");
  const [ratingChartData, setRatingChartData] = React.useState({
    avg: 0,
    total: 0,
    data: { "0": 0 },
  });

  const [bugChartData, setBugChartData] = React.useState({
    avg: 0,
    total: 0,
    data: { "0": 0 },
  });
  const [categoryChartData, setCategoryChartData] = React.useState({
    avg: 0,
    total: 0,
    data: {
      "No data": 0,
    },
  });
  const [TotalFbRatingChartData, setTotalFbRatingChartData] = React.useState(0);

  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const [isLoading, setIsloading] = React.useState(true);
  const [chartShow, setChartShow] = React.useState(false);
  const [render, setRender] = React.useState(true);
  const [categoryRender, setCategoryRender] = React.useState(true);

  const [proVerUrl, setproVerUrl] = React.useState("");
  const {
    userInfo,
    ProVersion,
    setProVersion,
    filterDate,
    setFilterDate,
    contextProVersion,
    setcontextProVersion,
    contextRedirectProdPage,
    enabledFeatures,
  } = useContext(UserContext) as UserLoginInfo;
  const [severityData, setSeverityData] = React.useState([] as any);
  const [SavedFilterSuccessToaster, setSavedFilterSuccessToaster] =
    React.useState(false);
  const [showSaveFilterBtn, setshowSaveFilterBtn] = React.useState(false);
  const [isFetching, setIsFetching] = React.useState(false);
  const [isFilterFetching, setIsFilterFetching] = React.useState(false);
  const [filterLastEvaluatedKey, setFilterLastEvaluatedKey] =
    React.useState<any>({});
  const [IsFilter, setIsFilter] = React.useState(false);
  const [CategoryData, setCategoryData] = React.useState([] as any);
  const [emailData, setEmailData] = React.useState([] as any);
  const currDate = new Date();
  const stDate = new Date(currDate);
  stDate.setHours(0, 0, 0, 0);
  currDate.setHours(23, 59, 59, 999);

  const ratings = [
    {
      name: "1 star rating",
      value: "1",
    },
    {
      name: "2 star rating",
      value: "2",
    },
    {
      name: "3 star rating",
      value: "3",
    },
    {
      name: "4 star rating",
      value: "4",
    },
    {
      name: "5 star rating",
      value: "5",
    },
  ];

  const [ratingsData, setRatingsData] = React.useState(ratings);

  const [insightsData, setInsightsData] = React.useState([] as any);
  const [insightSelected, setinsightSelected] = React.useState<any>("");
  const [TempInsightFlag, setTempInsightFlag] = React.useState(false);
  const [selectedProVerDataType, setselectedProVerDataType] =
    React.useState("confirm");

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "fetchInsightsData",
        component: "feedback",
        fileName: "filter.tsx",
        ratingChartData: ratingChartData,
      },
    });
  }, [ratingChartData, categoryChartData]);

  const fetchInsightsData = () => {
    if (proVerUrl) {
      Http.get<{ chartData: object }>({
        url: `/api/v2/chart/${pageType}?${proVerUrl}&xAxisData=Insights&count=10`,
        state: userInfo,
      })
        .then((response) => {
          setInsightsData(response.chartData);
          appLogger.info({
            infoObj: {
              method: "fetchInsightsData",
              component: "feedback",
              fileName: "filter.tsx",
              insightsData: response.chartData,
            },
          });
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
          props.snackbarShowMessage(error.message, "error");
          appLogger.error({
            errObj: {
              method: "fetchInsightsData",
              component: "feedback",
              fileName: "filter.tsx",
              err: error,
            },
          });
        });
    }
  };
  const handleTabChange = (event: any, newValue: number) => {
    appLogger.info({
      infoObj: {
        method: "handleTabChange",
        component: "feedback",
        fileName: "filter.tsx",
        value: newValue,
      },
    });
    setValue(newValue);
  };

  // useEffect(() => {
  //   window.addEventListener("scroll", filterhandleScroll);
  //   return () => window.removeEventListener("scroll", filterhandleScroll);
  // }, [filterLastEvaluatedKey]);

  const handleDrawerOpen = () => {
    setOpen(!open);
    fetchUserCount();
  };
  const resetValues = () => {
    appLogger.info(
      {
        infoObj: {
          method: "resetValues",
          component: "feedback",
          fileName: "filter.tsx",
        },
      },
      "reset Values called"
    );
    setFilterLastEvaluatedKey({});
    setUserData([]);
    setIsFetching(false);
    setIsFilterFetching(false);
  };
  const handleSelectFilter = (filter: {
    name: "";
    filters: [];
    advanceFilters: [];
  }) => {
    appLogger.info(
      {
        infoObj: {
          method: "resetValues",
          component: "feedback",
          fileName: "filter.tsx",
          filter: filter,
        },
      },
      "Filter Value"
    );

    const tempData = { ...filter };
    setSelectedFilter(tempData);
    setFilterLastEvaluatedKey({});
    setUserData([]);
    setshowSaveFilterBtn(false);
    resetValues();
    setIsFilterFetching(true);
    setTempInsightFlag(true);
  };

  const handleEditedFilter = (data: any) => {
    const tempData = { ...data };
    setSelectedFilter(tempData);
    appLogger.info({
      infoObj: {
        method: "handleEditedFilter",
        component: "feedback",
        fileName: "filter.tsx",
        tempData: tempData,
      },
    });
  };

  const handleKeyPress = (
    e: React.KeyboardEvent<HTMLDivElement> | React.MouseEvent<HTMLDivElement>
  ) => {
    setFilterLastEvaluatedKey({});
    setSearchKeyword(search);
    e.preventDefault();
    handleCloseAppliedFilter();
  };

  const handleSearchTyping = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearch(e.target.value);
    if (e.target.value.length < 1) {
      appLogger.info({
        infoObj: {
          method: "handleSearchTyping",
          component: "feedback",
          fileName: "filter.tsx",
          value: e.target.value,
        },
      });
      searchClear();
    }
  };
  const getSignedUrl = (url: string) => {
    return new Promise<string>((resolve, reject) => {
      // if (typeof url !== 'string') {
      //   return reject(new Error('url not valid'));
      // }

      // const urlSplit = url.split("/");
      // const name = urlSplit[urlSplit.length - 1];
      const pattern = "s3.amazonaws.com/";
      const name = encodeURIComponent(
        url?.substring(url?.indexOf(pattern) + pattern.length)
      ); //.replace('/', '%2F');

      Http.get({
        url: `/api/v2/signedurl/${name}`,
      })
        .then((response: any) => {
          if (response.filePath) {
            appLogger.info({
              infoObj: {
                method: "getSignedUrl",
                component: "feedback",
                fileName: "filter.tsx",
                filePath: response.filePath,
              },
            });
            return resolve(response.filePath);
          }
        })
        .catch((error) => {
          props.snackbarShowMessage(error.message, "error");
          appLogger.error({
            errObj: {
              method: "getSignedUrl",
              component: "feedback",
              fileName: "filter.tsx",
              err: error,
            },
          });
          return reject(error);
        });
    });
  };

  useEffect(() => {
    if (
      userInfo &&
      userInfo.idToken &&
      userInfo.idToken.length > 0 &&
      productResponse.length < 1
    ) {
      Http.get({
        url: `/api/v2/products/0`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.productNameList &&
            response.productNameList.length > 0
          ) {
            response &&
              response.productNameList &&
              response.productNameList.length > 0 &&
              response.productNameList.sort((a: any, b: any) =>
                a.name.localeCompare(b.name)
              );
            setProductResponse(response.productNameList);
            const extProd = response.productNameList.filter(
              (e: any) =>
                e.id == ProVersion.product && e.version == ProVersion.version
            );
            if (extProd.length > 0) {
              setProduct(response.productNameList[0].id);
              setVersion(response.productNameList[0].version);

              setProVersion({
                product: response.productNameList[0].id,
                version: response.productNameList[0].version,
              });
            } else {
              setProduct(ProVersion.product || response.productNameList[0].id);
              setVersion(
                ProVersion.version || response.productNameList[0].version
              );

              setProVersion({
                product: ProVersion.product || response.productNameList[0].id,
                version:
                  ProVersion.version || response.productNameList[0].version,
              });
            }
            let tempurl = "";
            if (Array.isArray(contextProVersion)) {
              const extProd = [];
              for (let i = 0; i < response.productNameList.length; i++) {
                for (let j = 0; j < contextProVersion.length; j++) {
                  if (
                    response.productNameList[i].id ==
                      contextProVersion[j].value &&
                    response.productNameList[i].version ==
                      contextProVersion[j].version
                  ) {
                    extProd.push(contextProVersion[j]);
                  }
                }
              }
              setcontextProVersion(extProd);
              setselectedProVerData(extProd);
              extProd.map((data: any) => {
                tempurl += `&prodId=${data.value}&prodVersion=${data.version}`;
              });
              setproVerUrl(tempurl);
            } else {
              setselectedProVerData([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                },
              ]);
              setcontextProVersion([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                  proversion:
                    response.productNameList[0].name +
                    response.productNameList[0].version,
                },
              ]);
              tempurl = `&prodId=${response.productNameList[0].id}&prodVersion=${response.productNameList[0].version}`;
              setproVerUrl(tempurl);
            }
            setIsloading(false);
          } else {
            setIsloading(false);
            if (
              !contextRedirectProdPage &&
              (userInfo?.userDetails?.userRole == ROLE_USER_SUPERADMIN ||
                userInfo?.userDetails?.userRole == ROLE_USER_MANAGER ||
                userInfo?.userDetails?.userRole == ROLE_USER_ADMIN)
            ) {
              // navigate("/products");
            }
          }
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "feedback",
              fileName: "filter.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
        });
      fetchFilterList();
    }
  }, [userInfo]);

  useEffect(() => {
    fetchFilteredData(appliedFilter);
    if (searchKeyword == "") {
      fetchCategoryChartData();
      fetchRatingChartData();
    }
  }, [searchKeyword]);

  const HandleProVer = (product: any, version: any) => {
    setProVersion({
      product: product,
      version: version,
    });
  };

  const selectedProVerDataFn = (data: any) => {
    let getData = data;
    getData = data;
    setselectedProVerData(data);

    HandleContextSelectedProVer(getData);

    setselectedProVerData(getData);
    let tempproVerUrl = "";
    getData &&
      getData.length > 0 &&
      getData.map((data: any, index: number) => {
        if (index === 0) {
          tempproVerUrl += `prodId=${data.value}&prodVersion=${data.version}`;
        } else {
          tempproVerUrl += `&prodId=${data.value}&prodVersion=${data.version}`;
        }
      });
    setproVerUrl(tempproVerUrl);
    setselectedProVerDataType(getData.type);
    setUserData([]);
    HandleContextSelectedProVer(getData);
  };
  const HandleContextSelectedProVer = (data: any) => {
    setcontextProVersion(data);
  };

  const fetchUserCount = () => {
    if (proVerUrl) {
      Http.get({
        url: `/api/v2/count/${pageType}?${proVerUrl}&countType=Uniq&count=10`,
        state: userInfo,
      })
        .then((response: any) => {
          appLogger.info({
            infoObj: {
              method: "fetchUserCount",
              component: "feedback",
              fileName: "filter.tsx",
              response: response,
            },
          });
          setEmailData(response.countData.data);
        })
        .catch((error) => {
          setIsloading(false);
          appLogger.error({
            errObj: {
              method: "fetchUserCount",
              component: "feedback",
              fileName: "filter.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
        });
    }
  };

  useEffect(() => {
    fetchUserCount();
  }, []);

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "feedback",
        fileName: "filter.tsx",
        CategoryData: CategoryData,
      },
    });
    if (CategoryData && CategoryData.length > 0) {
      setChartShow(true);
    }
  }, [CategoryData]);

  const fetchCategoryChartData = () => {
    // setCategoryRender(false);
    if (proVerUrl) {
      appLogger.info({
        infoObj: {
          method: "fetchCategoryChartData",
          component: "feedback",
          fileName: "filter.tsx",
          proVerUrl: proVerUrl,
        },
      });
      Http.get({
        url: `/api/v2/chart/${pageType}?${proVerUrl}&xAxisData=Category`,
        state: userInfo,
      })
        .then((response: any) => {
          setCategoryChartData(response.chartData);

          setCategoryData(Object.keys(response.chartData.data));
          setIsloading(false);
          // setCategoryRender(true);
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "fetchCategoryChartData",
              component: "feedback",
              fileName: "filter.tsx",
              error: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
        });
    }
  };

  const fetchRatingChartData = () => {
    setRender(false);
    if (proVerUrl) {
      setIsloading(true);
      appLogger.info({
        infoObj: {
          method: "fetchRatingChartData",
          component: "feedback",
          fileName: "filter.tsx",
          proVerUrl: proVerUrl,
        },
      });
      Http.get({
        url: `/api/v2/chart/${pageType}?${proVerUrl}&xAxisData=${
          pageType == "BUG_REPORT" ? "Severity" : "Rating"
        }`,
        state: userInfo,
      })
        .then((response: any) => {
          pageType == "BUG_REPORT"
            ? setBugChartData(response.chartData)
            : setRatingChartData(response.chartData);
          setTotalFbRatingChartData(response.chartData.total);
          pageType == "BUG_REPORT"
            ? setSeverityData(Object.keys(response.chartData.data))
            : [];
          appLogger.info({
            infoObj: {
              method: "fetchRatingChartData",
              component: "feedback",
              fileName: "filter.tsx",
              chartData: response.chartData,
            },
          });
          setChartShow(true);
          setRender(true);
          setIsloading(false);
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "fetchRatingChartData",
              component: "feedback",
              fileName: "filter.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
        });
    }
  };

  const fetchFilterList = () => {
    if (selectedProVerData) {
      setIsloading(true);
      Http.get({
        url: `/api/v2/filters?type=${pageType}`,
        state: userInfo,
      })
        .then((response: any) => {
          setIsloading(false);
          appLogger.info({
            infoObj: {
              method: "fetchFilterList",
              component: "feedback",
              fileName: "filter.tsx",
              response: response,
            },
          });
          setFilterResponse(response.filters);
          // setSelectedFilter(response.filters[0]);
        })
        .catch((error) => {
          setIsloading(false);
          appLogger.error({
            errObj: {
              method: "fetchFilterList",
              component: "feedback",
              fileName: "filter.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
        });
    }
  };

  const fetchFilteredData = (filterData: any) => {
    if (product && version && selectedProVerData) {
      let filterUrl = "";
      let addFilterUrl = "";
      if (
        isFilterFetching &&
        filterLastEvaluatedKey &&
        Object.keys(filterLastEvaluatedKey).length > 0
      ) {
        addFilterUrl = `&lastEvalKeyId=${filterLastEvaluatedKey.id}&lastEvalKeyfeedbackType=${pageType}&lastEvalKeyCreatedOn=${filterLastEvaluatedKey.createdOn}`;
      }
      if (filterData && filterData.filters && filterData.filters.length > 0) {
        appLogger.info({
          infoObj: {
            method: "fetchFilteredData",
            component: "feedback",
            fileName: "filter.tsx",
            data: { insightSelected, TempInsightFlag },
          },
        });
        appLogger.info({
          infoObj: {
            method: "fetchFilteredData",
            component: "feedback",
            fileName: "filter.tsx",
            filterData: filterData,
          },
        });

        // if (insightSelected) {
        //   filterUrl += `&filterSentiment=${insightSelected.keyWordType}&filterMentions=${insightSelected.keyName}`;
        // }

        filterData?.filters?.map((fieldData: any) => {
          switch (fieldData.field) {
            case "SENTIMENT":
              if (
                Array.isArray(fieldData.value) &&
                fieldData.value.length > 0
              ) {
                fieldData.value.map((data: any) => {
                  filterUrl += `&filterSentiment=${data}`;
                });
              } else {
                filterUrl += `&filterSentiment=${fieldData.value}`;
              }
              break;

            case "MENTIONS":
              if (
                Array.isArray(fieldData.value) &&
                fieldData.value.length > 0
              ) {
                fieldData.value.map((data: any) => {
                  filterUrl += `&filterMentions=${data}`;
                });
              } else {
                filterUrl += `&filterMentions=${fieldData.value}`;
              }
              break;
            // case "CATEGORY":
            //   filterUrl += `&filterCategory=${fieldData.value}`;
            //   break;

            case "CATEGORY":
              if (
                Array.isArray(fieldData.value) &&
                fieldData.value.length > 0
              ) {
                fieldData.value.map((data: any) => {
                  filterUrl += `&filterCategory=${data}`;
                });
              } else {
                filterUrl += `&filterCategory=${fieldData.value}`;
              }
              break;

            case "RATINGS":
              if (
                Array.isArray(fieldData.value) &&
                fieldData.value.length > 0
              ) {
                fieldData.value.map((data: any) => {
                  filterUrl += `&${
                    pageType == "BUG_REPORT" ? "filterSeverity" : "filterRating"
                  }=${pageType == "BUG_REPORT" ? data.toLowerCase() : data}`;
                });
              } else {
                filterUrl += `&${
                  pageType == "BUG_REPORT" ? "filterSeverity" : "filterRating"
                }=${
                  pageType == "BUG_REPORT"
                    ? fieldData.value.toLowerCase()
                    : fieldData.value
                }`;
              }
              break;

            case "METRIC":
              filterUrl += `&${pageType == "Metric"}=${
                pageType == fieldData.value.toLowerCase()
              }`;
              break;
            case "COMMENTS":
              filterUrl += `&filterComments=${fieldData.value}`;
              break;

            case "MENTIONS":
              if (
                Array.isArray(fieldData.value) &&
                fieldData.value.length > 0
              ) {
                fieldData.value.map((data: any) => {
                  filterUrl += `&filterMentions=${data}`;
                });
              } else {
                filterUrl += `&filterMentions=${fieldData.value}`;
              }
              break;
            case "EMAIL":
              if (
                Array.isArray(fieldData.value) &&
                fieldData.value.length > 0
              ) {
                fieldData.value.map((data: any) => {
                  filterUrl += `&filterUserId=${data}`;
                });
              } else {
                filterUrl += `&filterUserId=${fieldData.value}`;
              }
              break;

            case "ATTACHMENT":
              if (
                Array.isArray(fieldData.value) &&
                fieldData.value.length > 0
              ) {
                fieldData.value.map((data: any) => {
                  filterUrl += `&filterAttachment=${data}`;
                });
              } else {
                filterUrl += `&filterAttachment=${fieldData.value}`;
              }
              break;

            case "CONTEXT_DETAILS":
              filterUrl += `&filterContextDetails=${fieldData.value}`;
              break;
            case "USER_DETAILS":
              filterUrl += `&filterUserDetails=${fieldData.value}`;
              break;
            case "PLATFORM_DETAILS":
              filterUrl += `&filterPlatformInfo=${fieldData.value}`;
              break;
            case "PAGE_DETAILS":
              filterUrl += `&filterPageInfo=${fieldData.value}`;
              break;
            case "START_DATE":
              filterUrl += `&startDate=${fieldData.value}`;
              break;
            case "END_DATE":
              filterUrl += `&endDate=${fieldData.value}`;
              break;
            default:
              filterUrl += "";
          }
        });
      }
      if (
        filterData &&
        filterData.advanceFilters &&
        filterData.advanceFilters.length > 0
      ) {
        filterData.advanceFilters &&
          filterData.advanceFilters.length > 0 &&
          filterData.advanceFilters.map((fieldData: any) => {
            switch (fieldData.field) {
              // case "CATEGORY":
              //   filterUrl += `&filterCategory=${fieldData.value}`;
              //   break;

              case "CATEGORY":
                if (
                  Array.isArray(fieldData.value) &&
                  fieldData.value.length > 0
                ) {
                  fieldData.value.map((data: any) => {
                    filterUrl += `&filterCategory=${data}`;
                  });
                } else {
                  filterUrl += `&filterCategory=${fieldData.value}`;
                }
                break;

              case "RATINGS":
                if (
                  Array.isArray(fieldData.value) &&
                  fieldData.value.length > 0
                ) {
                  fieldData.value.map((data: any) => {
                    filterUrl += `&${
                      pageType == "BUG_REPORT"
                        ? "filterSeverity"
                        : "filterRating"
                    }=${pageType == "BUG_REPORT" ? data.toLowerCase() : data}`;
                  });
                } else {
                  filterUrl += `&${
                    pageType == "BUG_REPORT" ? "filterSeverity" : "filterRating"
                  }=${
                    pageType == "BUG_REPORT"
                      ? fieldData.value.toLowerCase()
                      : fieldData.value
                  }`;
                }
                break;

              case "COMMENTS":
                filterUrl += `&filterComments=${fieldData.value}`;
                break;
              // case "MENTIONS":
              //   filterUrl += `&filterMentions=${fieldData.value}`;
              // break;
              case "EMAIL":
                filterUrl += `&filterUserId=${fieldData.value}`;
                break;
              case "CONTEXT_DETAILS":
                filterUrl += `&filterContextDetails=${fieldData.value}`;
                break;
              case "USER_DETAILS":
                filterUrl += `&filterUserDetails=${fieldData.value}`;
                break;
              case "PLATFORM_DETAILS":
                filterUrl += `&filterPlatformInfo=${fieldData.value}`;
                break;
              case "PAGE_DETAILS":
                filterUrl += `&filterPageInfo=${fieldData.value}`;
                break;
              case "START_DATE":
                filterUrl += `&startDate=${fieldData.value}`;
                break;
              case "END_DATE":
                filterUrl += `&endDate=${fieldData.value}`;
                break;
              default:
                filterUrl += "";
            }
          });
      }
      let x = filterUrl;
      x = Array.from(new Set(x.split("&"))).toString();
      if (
        !filterLastEvaluatedKey ||
        Object.keys(filterLastEvaluatedKey).length < 1
      ) {
        setIsloading(true);
      } else {
        setIsFetching(true);
      }
      if (proVerUrl) {
        let searchURL = "";

        if (searchKeyword) {
          searchURL = `&search=${searchKeyword}`;
        }

        Http.get<FeedbackResponse>({
          url: `/api/v2/userFeedback/${pageType}?${proVerUrl}&${filterUrl}${searchURL}${addFilterUrl}&items=10`,
          state: userInfo,
        })
          .then((response) => {
            if (
              response &&
              response.Items &&
              response.Items.Items &&
              response.Items.Items.length > 0 &&
              // response.Items.Items[0].productId !== product &&
              filterLastEvaluatedKey &&
              Object.keys(filterLastEvaluatedKey).length > 0
            ) {
              const records = new Set([...userData, ...response.Items.Items]);
              const arrRecords = Array.from(records);
              setUserData(arrRecords);
              setFilterLastEvaluatedKey(response.Items.LastEvaluatedKey);
              appLogger.info(
                {
                  infoObj: {
                    method: "fetchFilteredData",
                    component: "feedback",
                    fileName: "filter.tsx",
                    response: response,
                  },
                },
                "unfiltered with lasteval"
              );
              setIsFilterFetching(false);
              setIsFetching(false);
            } else {
              appLogger.info(
                {
                  infoObj: {
                    method: "fetchFilteredData",
                    component: "feedback",
                    fileName: "filter.tsx",
                    response: response,
                  },
                },
                "unfiltered"
              );
              setUserData(response.Items.Items);
              setFilterLastEvaluatedKey(response.Items.LastEvaluatedKey);
              appLogger.info({
                infoObj: {
                  method: "fetchFilteredData",
                  component: "feedback",
                  fileName: "filter.tsx",
                  lastEcaluatedKay: response.Items.LastEvaluatedKey,
                },
              });
              setIsFilterFetching(false);
              setIsFetching(false);
            }
          })

          .catch((error) => {
            appLogger.error({
              errObj: {
                method: "fetchFilteredData",
                component: "feedback",
                fileName: "filter.tsx",
                err: error,
              },
            });
            props.snackbarShowMessage(error.message, "error");
          });

        if (
          (proVerUrl && !filterLastEvaluatedKey) ||
          Object.keys(filterLastEvaluatedKey).length < 1
        ) {
          Http.get({
            url: `/api/v2/chart/${pageType}?${proVerUrl}&xAxisData=${
              pageType == "BUG_REPORT" ? "Severity" : "Rating"
            }${filterUrl}${searchURL}`,
            state: userInfo,
          })
            .then((response: any) => {
              if (
                (appliedFilter?.filters?.length &&
                  appliedFilter?.filters?.find(
                    (e: any) => e.field !== "RATINGS"
                  )) ||
                (appliedFilter?.filters?.length > 0 &&
                  selectedFilter?.filters?.length > 0)
              ) {
                // setRender(false);
                pageType == "BUG_REPORT"
                  ? setBugChartData(response.chartData)
                  : setRatingChartData(response.chartData);

                // setTimeout(() => {
                //   setRender(true);
                // });
              }
            })
            .catch((error) => {
              appLogger.error({
                errObj: {
                  method: "fetchFilteredData",
                  component: "feedback",
                  fileName: "filter.tsx",
                  err: error,
                },
              });
              props.snackbarShowMessage(error.message, "error");
            });

          Http.get({
            url: `/api/v2/chart/${pageType}?${proVerUrl}&xAxisData=Category${filterUrl}${searchURL}`,
            state: userInfo,
          })
            .then((response: any) => {
              if (
                (appliedFilter?.filters?.length &&
                  appliedFilter?.filters?.find(
                    (e: any) => e.field !== "CATEGORY"
                  )) ||
                (appliedFilter?.filters?.length > 0 &&
                  selectedFilter?.filters?.length > 0) ||
                searchURL
              ) {
                // setRender(false);
                // setCategoryRender(false);
                setCategoryChartData(response.chartData);
                // setTimeout(() => {
                //   setCategoryRender(true);
                //   setRender(true);
                // });
              }
              appLogger.info(
                {
                  infoObj: {
                    method: "fetchFilteredData",
                    component: "feedback",
                    fileName: "filter.tsx",
                    response: response,
                  },
                },
                "chartDataUpdate"
              );

              if (CategoryData && CategoryData.length == 0) {
                setCategoryData(Object.keys(response.chartData.data));
              }
              setIsloading(false);
            })
            .catch((error) => {
              setIsloading(false);
              props.snackbarShowMessage(error.message, "error");
              appLogger.error({
                errObj: {
                  method: "fetchFilteredData",
                  component: "feedback",
                  fileName: "filter.tsx",
                  err: error,
                },
              });
            });
          appLogger.info(
            {
              infoObj: {
                method: "fetchFilteredData",
                component: "feedback",
                fileName: "filter.tsx",
                filterUrl: filterUrl,
              },
            },
            "filterUrl"
          );
          if (enableInsights && enabledFeatures?.enableInsights) {
            Http.get({
              url: `/api/v2/chart/${pageType}?${proVerUrl}&xAxisData=Insights${filterUrl}${searchURL}&count=10`,
              state: userInfo,
            })
              .then((response: any) => {
                appLogger.info(
                  {
                    infoObj: {
                      method: "fetchFilteredData",
                      component: "feedback",
                      fileName: "filter.tsx",
                      response: response,
                    },
                  },
                  "chartDataUpdate"
                );
                setInsightsData(response.chartData);

                if (CategoryData && CategoryData.length == 0) {
                  setCategoryData(Object.keys(response.chartData.data));
                }
                setIsloading(false);
              })
              .catch((error) => {
                setIsloading(false);
                props.snackbarShowMessage(error.message, "error");
                appLogger.error({
                  errObj: {
                    method: "fetchFilteredData",
                    component: "feedback",
                    fileName: "filter.tsx",
                    err: error,
                  },
                });
              });
          }
        }

        if (
          (proVerUrl &&
            (!filterLastEvaluatedKey ||
              Object.keys(filterLastEvaluatedKey).length < 1)) ||
          searchKeyword
        ) {
          Http.get({
            url: `/api/v2/chart/${pageType}?${proVerUrl}&xAxisData=${
              pageType == "BUG_REPORT" ? "Severity" : "Rating"
            }${filterUrl}${searchURL}`,
            state: userInfo,
          })
            .then((response: any) => {
              if (
                (appliedFilter?.filters?.length &&
                  appliedFilter?.filters?.find(
                    (e: any) => e.field !== "RATINGS"
                  )) ||
                (appliedFilter?.filters?.length > 0 &&
                  selectedFilter?.filters?.length > 0) ||
                searchURL
              ) {
                // setRender(false);
                pageType == "BUG_REPORT"
                  ? setBugChartData(response.chartData)
                  : setRatingChartData(response.chartData);

                // setTimeout(() => {
                //   setRender(true);
                // });
              }
            })
            .catch((error) => {
              appLogger.error({
                errObj: {
                  method: "fetchFilteredData",
                  component: "feedback",
                  fileName: "filter.tsx",
                  err: error,
                },
              });
              props.snackbarShowMessage(error.message, "error");
            });

          Http.get({
            url: `/api/v2/chart/${pageType}?${proVerUrl}&xAxisData=Category${filterUrl}${searchURL}`,
            state: userInfo,
          })
            .then((response: any) => {
              if (
                (appliedFilter?.filters?.length &&
                  appliedFilter?.filters?.find(
                    (e: any) => e.field !== "CATEGORY"
                  )) ||
                (appliedFilter?.filters?.length > 0 &&
                  selectedFilter?.filters?.length > 0)
              ) {
                setCategoryChartData(response.chartData);
              }
              setFilteredTotal(response.chartData.total);
              appLogger.info(
                {
                  infoObj: {
                    method: "fetchFilteredData",
                    component: "feedback",
                    fileName: "filter.tsx",
                    response: response,
                  },
                },
                "chartDataUpdate"
              );

              if (CategoryData && CategoryData.length == 0) {
                setCategoryData(Object.keys(response.chartData.data));
              }
              setIsloading(false);
            })
            .catch((error) => {
              setIsloading(false);
              props.snackbarShowMessage(error.message, "error");
              appLogger.error({
                errObj: {
                  method: "fetchFilteredData",
                  component: "feedback",
                  fileName: "filter.tsx",
                  err: error,
                },
              });
            });
        }
      }

      setFilterUrlData(filterUrl);
      setAddFilterUrlData(addFilterUrl);
    }
  };

  const handleFilterTitle = (event: any) => {
    const value = (event.target as HTMLInputElement).value;
    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      temp.name = value;
      setSelectedFilter(temp);
    }
  };

  const humanize = (str: any) => {
    return str
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/(?: |\b)(\w)/g, function (key: any) {
        return key.toUpperCase();
      });
  };

  const changeStartDateValue = (e: any) => {
    const selectedDateString = e.target.value;
    const dt = new Date(selectedDateString);
    dt.setHours(0, 0, 0, 0);
    const timestamp = dt.getTime();
    const utcDate = timestamp;
    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      if (
        temp &&
        temp.filters &&
        temp.filters.find((data: any) => data.field === "START_DATE")
      ) {
        temp.filters.map((data: any) => {
          if (data.field === "START_DATE") {
            data.value = utcDate;
          }
        });
        setSelectedFilter(temp);
      } else {
        const startDateField = {
          field: "START_DATE",
          operation: "contains",
          value: utcDate,
        };
        if (temp.filters) {
          temp.filters.push(startDateField);
        } else {
          temp.filters = [];
          temp.filters.push(startDateField);
        }
        setSelectedFilter(temp);
      }
    }
  };

  const changeEndDateValue = (e: any) => {
    const selectedDateString = e.target.value;
    const dt = new Date(selectedDateString);
    dt.setHours(23, 59, 59, 999);
    const timestamp = dt.getTime();
    const utcDate = timestamp;

    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      if (
        temp &&
        temp.filters &&
        temp.filters.find((data: any) => data.field === "END_DATE")
      ) {
        temp.filters.map((data: any) => {
          if (data.field === "END_DATE") {
            data.value = utcDate;
          }
        });
        setSelectedFilter(temp);
      } else {
        const endDateField = {
          field: "END_DATE",
          operation: "contains",
          value: utcDate,
        };
        if (temp.filters) {
          temp.filters.push(endDateField);
        } else {
          temp.filters = [];
          temp.filters.push(endDateField);
        }
        setSelectedFilter(temp);
      }
    }
  };

  const selectFilter = (event: SelectChangeEvent) => {
    // Removed setFilter from this func as filter was unused making setting the state pointless
  };

  const selectFilterRating = (e: unknown, selectedData: any) => {
    appLogger.info({
      infoObj: {
        method: "selectFilterRating",
        component: "feedback",
        fileName: "filter.tsx",
        value: selectedData,
      },
    });
    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      if (
        temp &&
        temp.filters &&
        selectedData.length > 0 &&
        temp.filters.find((data: any) => data.field === "RATINGS")
      ) {
        temp.filters.map((data: any) => {
          if (data.field === "RATINGS") {
            data.value = selectedData;
          }
        });
        setSelectedFilter(temp);
      } else if (
        selectedData.length === 0 &&
        temp.filters.find((data: any) => data.field === "RATINGS")
      ) {
        temp.filters = temp.filters.filter((data: any) => {
          return data.field !== "RATINGS";
        });
        setSelectedFilter(temp);
      } else {
        const ratingField = {
          field: "RATINGS",
          operation: "contains",
          value: selectedData,
        };
        if (temp.filters) {
          temp.filters.push(ratingField);
        } else {
          temp.filters = [];
          temp.filters.push(ratingField);
        }
        setSelectedFilter(temp);
      }
    }
  };

  const selectFilterCategory = (e: any, selectedData: any) => {
    appLogger.info({
      infoObj: {
        method: "selectFilterCategory",
        component: "feedback",
        fileName: "filter.tsx",
        value: selectedData,
      },
    });
    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      if (
        temp &&
        temp.filters &&
        selectedData.length > 0 &&
        temp.filters.find((data: any) => data.field === "CATEGORY")
      ) {
        temp.filters.map((data: any) => {
          if (data.field === "CATEGORY") {
            data.value = selectedData;
          }
        });
        setSelectedFilter(temp);
      } else if (
        selectedData.length === 0 &&
        temp.filters.find((data: any) => data.field === "CATEGORY")
      ) {
        temp.filters = temp.filters.filter((data: any) => {
          return data.field !== "CATEGORY";
        });
        setSelectedFilter(temp);
      } else {
        const ratingField = {
          field: "CATEGORY",
          operation: "contains",
          value: selectedData,
        };
        if (temp.filters) {
          temp.filters.push(ratingField);
        } else {
          temp.filters = [];
          temp.filters.push(ratingField);
        }
        setSelectedFilter(temp);
      }
    }
  };

  const handleAddCustomFilter = () => {
    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      if (temp && temp.advanceFilters) {
        const newAdvanceFilter = {
          field: "",
          operation: "",
          value: "",
        };
        temp.advanceFilters.push(newAdvanceFilter);
        setSelectedFilter(temp);
      } else {
        temp.advanceFilters = [];
        const newAdvanceFilter = {
          field: "",
          operation: "",
          value: "",
        };
        temp.advanceFilters.push(newAdvanceFilter);
        setSelectedFilter(temp);
      }
    }
  };

  const handlefilterEdit = (filterData: any) => {
    const tempData = { ...filterData };
    handleEditedFilter(JSON.parse(JSON.stringify(tempData)));
    handleTabChange("1", 0);
  };
  const handleFilterEditClicked = (data: any) => {
    handleDrawerOpen();
    const getSelectedFilterId = filterResponse.find(
      (d: any) => d.name === data.name
    );
    if (getSelectedFilterId) {
      appliedFilter.id = getSelectedFilterId.id;
    }
    appLogger.info({
      infoObj: {
        method: "handlefilterEdit",
        component: "feedback",
        fileName: "filter.tsx",
        getSelectedFilterId: getSelectedFilterId,
      },
    });
    handlefilterEdit(appliedFilter);
  };

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "feedback",
        fileName: "filter.tsx",
        filterData: { appliedFilter, selectedFilter },
      },
    });
  }, [appliedFilter, selectedFilter]);

  useEffect(() => {
    if (SavedFilterSuccessToaster) {
      setTimeout(function () {
        setSavedFilterSuccessToaster(false);
      }, 2000);
    }
  }, [SavedFilterSuccessToaster]);

  const [prevChartData, setPrevChartData] = useState([] as any);

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "feedback",
        fileName: "filter.tsx",
        prevChartData: prevChartData,
      },
    });

    if (prevChartData && prevChartData.length > 0) {
      let temp: any = [...prevChartData];
      if (appliedFilter?.filters?.length) {
        temp = [...new Set([...appliedFilter?.filters, ...prevChartData])];

        const key = "field";

        const arrayUniqueByKey = [
          ...new Map(temp.map((item: any) => [item[key], item])).values(),
        ];

        temp = arrayUniqueByKey.filter((n: any) => n.value.length != 0);
      }

      // k.filter((e: any) => {
      //   e.field;
      // });

      const test: any = {
        name: "",
        filters: temp,
        advanceFilters: [],
        isDelete: prevChartData?.[0]?.field === "DELETE",
      };

      if (prevChartData && prevChartData.length > 0) {
        applyFilter("", test, "");
      }
    }
  }, [prevChartData]);

  const setChartData = (data: any) => {
    appLogger.info({
      infoObj: {
        method: "setChartData",
        component: "feedback",
        fileName: "filter.tsx",
        data: { data, search },
      },
    });
    appLogger.info(
      {
        infoObj: {
          method: "setChartData",
          component: "feedback",
          fileName: "filter.tsx",
          data: { appliedFilter, selectedFilter },
        },
      },
      "selectedfiltertest"
    );

    setFilterDate({
      startDate: "",
      endDate: "",
    });

    setPrevChartData((prevChartData: any) => {
      setIsloading(true);
      setshowSaveFilterBtn(true);

      appLogger.info(
        {
          infoObj: {
            method: "setPrevChartData",
            component: "feedback",
            fileName: "filter.tsx",
            data: { data },
          },
        },
        "prevChartData test"
      );

      if (
        data &&
        data.value.length > 0 &&
        prevChartData &&
        prevChartData.length > 0
      ) {
        const tempData = [...prevChartData, data];
        return tempData;
      }
      if (data) {
        const startDateValue = {
          field: "START_DATE",
          operation: "contains",
          value: filterDate.startDate || "",
        };
        const endDateValue = {
          field: "END_DATE",
          operation: "contains",
          value: filterDate.endDate || "",
        };
        let filterParams = [];
        if (filterDate.startDate && filterDate.endDate) {
          filterParams = [data, startDateValue, endDateValue];
          // setFilterDate({
          //   startDate: "",
          //   endDate: "",
          // });
          return filterParams;
        }
        const tempData = [data];
        return tempData;
      }
    });

    setTimeout(() => {
      setIsloading(false);
      setChartShow(true);
    });
  };

  const handleCloseAppliedFilter = () => {
    appLogger.info({
      infoObj: {
        method: "handleCloseAppliedFilter",
        component: "feedback",
        fileName: "filter.tsx",
        data: { selectedFilter, insightSelected },
      },
    });

    // setRender(false);
    // setCategoryRender(false);

    // setTimeout(() => {
    //   setRender(true);
    //   setCategoryRender(true);
    // }, 1000);

    setSelectedFilter({ filters: [] });
    navigate(location.pathname, { replace: true });

    setAppliedFilter({});
    if (!insightSelected) {
      // fetchCategoryChartData();
      // fetchRatingChartData();
      setPrevChartData([]);
      setChartData("");
      setUserData([]);
    }
    // fetchFilteredData("");
    setIsFilter(false);
  };

  const searchClear = () => {
    setSearch("");
    setSearchKeyword("");
  };

  const handleFilterDelete = (event: any, filterData: any) => {
    if (filterData && filterData.id) {
      Http.deleteReq({
        url: `/api/v2/filters/${filterData.id}`,
        state: userInfo,
      })
        .then((response: any) => {
          props.snackbarShowMessage("Filter Deleted Successfully", "success");
          appLogger.info({
            infoObj: {
              method: "handleFilterDelete",
              component: "feedback",
              fileName: "filter.tsx",
              deleteFilterResponse: response,
            },
          });
          fetchFilterList();
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "handleFilterDelete",
              component: "feedback",
              fileName: "filter.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
        });
    }
  };

  const selectCustomFilterAttribute = (event: any, index: number) => {
    const value = (event.target as HTMLInputElement).value;
    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      if (temp && temp.advanceFilters) {
        temp.advanceFilters[index].field = value;
      }
      setSelectedFilter(temp);
    }
  };

  const selectCustomFilterCondition = (
    event: SelectChangeEvent,
    index: number
  ) => {
    const value = (event.target as HTMLInputElement).value;
    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      if (temp && temp.advanceFilters) {
        temp.advanceFilters[index].operation = value;
      }
      setSelectedFilter(temp);
    }
  };

  const selectCustomFilterValue = (event: any, index: number) => {
    const value = (event.target as HTMLInputElement).value;
    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      if (temp && temp.advanceFilters) {
        temp.advanceFilters[index].value = value;
      }
      setSelectedFilter(temp);
    }
  };

  const removeAdvFilter = (index: number) => {
    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      if (temp && temp.advanceFilters) {
        appLogger.info({
          infoObj: {
            method: "removeAdvFilter",
            component: "feedback",
            fileName: "filter.tsx",
            advanceFilters: temp.advanceFilters,
            selectedFilter: selectedFilter,
          },
        });
        temp.advanceFilters.splice(index, 1);
        appLogger.info({
          infoObj: {
            method: "removeAdvFilter",
            component: "feedback",
            fileName: "filter.tsx",
            advanceFilters: temp.advanceFilters,
          },
        });
        setSelectedFilter(temp);
      }
    }
  };

  const applyFilter = (event: any, filterData: any, type: any) => {
    if (
      filterData?.filters?.length === 0 ||
      (!appliedFilter && selectedFilter.filters.length === 0)
    ) {
      setRender(false);
      setCategoryRender(false);

      setTimeout(() => {
        setRender(true);
        setCategoryRender(true);
      });

      fetchRatingChartData();
      fetchCategoryChartData();
    }

    if (filterData.isDelete) {
      fetchRatingChartData();
      fetchCategoryChartData();
      setChartData("");
    }

    setUserData([]);
    setPrevChartData([]);
    setIsFilter(true);
    appLogger.info({
      infoObj: {
        method: "applyFilter",
        component: "feedback",
        fileName: "filter.tsx",
        filterData: filterData,
      },
    });
    setSavedFilterSuccessToaster(false);
    setIsloading(true);
    if (!filterData.isDelete) {
      const tempData = JSON.parse(JSON.stringify(filterData));
      setAppliedFilter(tempData);
    }
    setFilterLastEvaluatedKey({});
    setIsFilterFetching(true);

    if (type == "apply") {
      handleDrawerOpen();
    }
  };

  const handleFilterSave = (event: any, selectedFilter: any, type: any) => {
    setUserData([]);
    /***************** Save Filter Function Add, Edit ****************************/

    // if (!(productParams && productParams.products && productParams.products[0] &&
    //   productParams.products[0].version)) {
    appLogger.info({
      infoObj: {
        method: "handleFilterSave",
        component: "feedback",
        fileName: "filter.tsx",
        advanceFilters: selectedFilter?.advanceFilters,
      },
    });
    let noError = true;

    if (selectedFilter && selectedFilter.advanceFilters) {
      selectedFilter.advanceFilters.map((value: any) => {
        appLogger.info({
          infoObj: {
            method: "handleFilterSave",
            component: "feedback",
            fileName: "filter.tsx",
            value: value,
          },
        });
        if (!value.field) {
          props.snackbarShowMessage(
            "You must provide advance filter attribute",
            "error",
            3000
          );
          noError = false;
        } else if (!value.operation) {
          props.snackbarShowMessage(
            "You must provide advance filter contains",
            "error",
            3000
          );
          noError = false;
        } else if (!value.value) {
          props.snackbarShowMessage(
            "You must provide advance filter value",
            "error",
            3000
          );
          noError = false;
        }
      });
    }

    if (type == "save") {
      setIsloading(true);

      if (selectedFilter && selectedFilter.id && noError) {
        selectedFilter.feedbackType = pageType;
        const postData: any = { filters: [{ ...selectedFilter }] };
        appLogger.info({
          infoObj: {
            method: "handleFilterSave",
            component: "feedback",
            fileName: "filter.tsx",
            postData: postData,
            selectedFilter: selectedFilter,
          },
        });
        Http.put({
          url: `/api/v2/filters`,
          body: {
            ...postData,
          },
          state: userInfo,
        })
          .then((response: any) => {
            if (response.message === "Filter already exists") {
              props.snackbarShowMessage("Filter already exists", "error");
              setshowSaveFilterBtn(false);
              setAppliedFilter({});
            } else {
              appLogger.info({
                infoObj: {
                  method: "handleFilterSave",
                  component: "feedback",
                  fileName: "filter.tsx",
                  response: response,
                },
              });
              // fetchFilterList();
              // setIsloading(false);
              // setSavedFilterSuccessToaster(false);
              props.snackbarShowMessage("Data updated Successfully", "success");
            }
          })
          .catch((error) => {
            appLogger.error({
              errObj: {
                method: "handleFilterSave",
                component: "feedback",
                fileName: "filter.tsx",
                err: error,
              },
            });
            props.snackbarShowMessage(error.message, "error");
          });
      } else if (selectedFilter && noError) {
        selectedFilter.feedbackType = pageType;
        const postData: any = { filters: [{ ...selectedFilter }] };
        appLogger.info({
          infoObj: {
            method: "handleFilterSave",
            component: "feedback",
            fileName: "filter.tsx",
            postData: postData,
            selectedFilter: selectedFilter,
          },
        });
        Http.post({
          url: `/api/v2/filters`,
          body: {
            ...postData,
          },
          state: userInfo,
        })
          .then((response: any) => {
            // setSelectedQuestionnairePosted(true);
            appLogger.info({
              infoObj: {
                method: "handleFilterSave",
                component: "feedback",
                fileName: "filter.tsx",
                response: response,
              },
            });
            if (response.message === "Filter already exists") {
              props.snackbarShowMessage("Filter already exists", "error");
              setshowSaveFilterBtn(false);
              setAppliedFilter({});
            } else {
              fetchFilterList();
              setIsloading(false);
              setSavedFilterSuccessToaster(true);
              setshowSaveFilterBtn(false);
              props.snackbarShowMessage("Data Added Successfully", "success");
            }
          })
          .catch((error) => {
            const perror = JSON.stringify(error);
            appLogger.info({
              infoObj: {
                method: "handleFilterSave",
                component: "feedback",
                fileName: "filter.tsx",
                err: error,
              },
            });
            props.snackbarShowMessage(error.message, "error");
          });
      }
      applyFilter(event, selectedFilter, "");
    } else if (noError) {
      applyFilter(event, selectedFilter, "apply");
      setshowSaveFilterBtn(true);
    }
    setOpen(false);
  };

  const fetchMoreUserData = () => {
    setIsFilterFetching(true);
  };

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "feedback",
        fileName: "filter.tsx",
        userDate: userData,
      },
    });
  }, [userData]);

  useEffect(() => {
    if (isFilterFetching && IsFilter && filterLastEvaluatedKey) {
      fetchFilteredData(appliedFilter);
    } else if (isFilterFetching && filterLastEvaluatedKey) {
      fetchFilteredData("");
    } else {
      setIsFilterFetching(false);
    }
  }, [isFilterFetching]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (!location) {
      setFilterDate({
        startDate: "",
        endDate: "",
      });
    }
  }, [location, insightSelected]);

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "feedback",
        fileName: "filter.tsx",
        locationData: { location },
      },
    });
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "feedback",
        fileName: "filter.tsx",
        filterdate: {
          filterDate,
          appliedFilter,
          selectedFilter,
          filterUrlData,
        },
      },
    });

    const locState = location.state as { ratingsClicked: { field: string } };
    if (locState?.ratingsClicked && product && version) {
      setFilterDate({
        startDate: "",
        endDate: "",
      });
      setChartData(locState.ratingsClicked);

      if (locState.ratingsClicked?.field !== "EMAIL") {
        fetchRatingChartData();
        fetchCategoryChartData();
      }
      navigate(location.pathname, { replace: true });
      setFilterDate({
        startDate: "",
        endDate: "",
      });
      setshowSaveFilterBtn(true);
    }

    if (
      stateValue &&
      stateValue.state &&
      stateValue.state.keyName &&
      product &&
      version
    ) {
      const insightSelectedData = {
        keyWordType: stateValue.state.keyWordType,
        i: stateValue.state.insight,
        keyName: stateValue.state.keyName,
      };
      appLogger.info({
        infoObj: {
          method: "useEffect",
          component: "feedback",
          fileName: "filter.tsx",
          insightSelectedData: insightSelectedData,
        },
      });
      setinsightSelected(insightSelectedData);

      const insightObj = {
        field: "MENTIONS",
        operation: "contains",
        value: [stateValue.state.keyName],
      };

      const insightObjNew = {
        field: "SENTIMENT",
        operation: "contains",
        value: [stateValue.state.keyWordType],
      };

      const startDateValue = {
        field: "START_DATE",
        operation: "contains",
        value: filterDate.startDate || "",
      };

      const endDateValue = {
        field: "END_DATE",
        operation: "contains",
        value: filterDate.endDate || "",
      };

      appLogger.info({
        infoObj: {
          method: "useEffect",
          component: "feedback",
          fileName: "filter.tsx",
          filterDate: { startDate: filterDate.startDate },
        },
      });

      let filterParams: any = [];
      if (filterDate.startDate && filterDate.endDate) {
        filterParams = [startDateValue, endDateValue];
      }

      if (insightObj && insightObjNew) {
        const k = [insightObj, insightObjNew];
        k.map((e: any) => {
          filterParams.push(e);
        });
      }

      // const insightSentiment = {
      //   field: "SENTIMENT",
      //   operation: "contains",
      //   value: stateValue.state.keyWordType,
      // };
      const params = {
        name: "",
        filters: filterParams,
      };
      applyFilter("", params, "");
    }
  }, [selectedProVerData]);

  const chipFilter = (i: any, keyWordType: any, item: any, keyName: any) => {
    const insightSelectedData = {
      keyWordType: keyWordType,
      i: i,
      keyName: keyName,
    };
    appLogger.info({
      infoObj: {
        method: "chipFilter",
        component: "feedback",
        fileName: "filter.tsx",
        data: { insightSelectedData, appliedFilter, selectedFilter },
      },
    });
    const insightObj = {
      field: "MENTIONS",
      operation: "contains",
      value: [insightSelectedData.keyName],
    };

    const insightObjNew = {
      field: "SENTIMENT",
      operation: "contains",
      value: [insightSelectedData.keyWordType],
    };

    const filterParams: any = [];

    appliedFilter &&
      appliedFilter?.filters?.map((e: any) => {
        if (e.field === "MENTIONS" && e.value[0] === insightObj.value[0]) {
          insightObj.value.pop();
        }
      });

    appliedFilter &&
      appliedFilter?.filters?.map((e: any) => {
        if (e.field === "SENTIMENT" && e.value[0] === insightObjNew.value[0]) {
          insightObjNew.value.pop();
        }
      });

    if (insightObj && insightObj.value.length) {
      appLogger.info({
        infoObj: {
          method: "chipFilter",
          component: "feedback",
          fileName: "filter.tsx",
          insightObj: insightObj,
        },
      });
      filterParams.push(insightObj);
    }

    if (insightObjNew && insightObjNew.value.length) {
      filterParams.push(insightObjNew);
    }

    // let appFilter = []

    const params: any = {
      name: "",
      advanceFilters: [],
      filters:
        appliedFilter && appliedFilter?.filters
          ? [...appliedFilter?.filters, ...filterParams]
          : filterParams,
    };

    setinsightSelected(insightSelectedData);

    applyFilter("", params, "");
  };

  const removeFilter = (data: any) => {
    let params: any;
    appLogger.info(
      {
        infoObj: {
          method: "removeFilter",
          component: "feedback",
          fileName: "filter.tsx",
          data: data,
        },
      },
      "remove filter field"
    );
    if (data.field == "START_DATE" || data.field == "END_DATE") {
      setFilterDate({
        startDate: "",
        endDate: "",
      });

      params = {
        name: appliedFilter.name,
        filters: [
          ...appliedFilter.filters.filter(
            (item: any) =>
              item.field !== "START_DATE" && item.field !== "END_DATE"
          ),
        ],
        advanceFilters: [],
      };
    } else if (typeof data.value === "string") {
      params = {
        name: appliedFilter.name,
        filters: [
          ...appliedFilter.filters.filter(
            (item: any) => item.field !== data.field
          ),
        ],
        advanceFilters: [],
      };
      appLogger.info({
        infoObj: {
          method: "removeFilter",
          component: "feedback",
          fileName: "filter.tsx",
          data: { value: data.value, appliedFilter: appliedFilter },
        },
      });
    } else if (Array.isArray(data.value)) {
      if (data.value.length === 0) {
        if (data.field === "MENTIONS") {
          params = {
            name: appliedFilter.name,
            filters: [
              ...appliedFilter.filters.filter(
                (item: any) =>
                  !(item.field === data.field && item.value === data.value)
              ),
            ],
            advanceFilters: [],
          };
        } else if (data.field === "SENTIMENT") {
          params = {
            name: appliedFilter.name,
            filters: [
              ...appliedFilter.filters.filter(
                (item: any) =>
                  !(item.field === data.field && item.value === data.value)
              ),
            ],
            advanceFilters: [],
          };
        } else {
          params = {
            name: appliedFilter.name,
            filters: [
              ...appliedFilter.filters.filter(
                (item: any) => item.field !== data.field
              ),
            ],
            advanceFilters: [],
          };
        }
      } else {
        params = {
          name: appliedFilter.name,
          filters: [...appliedFilter.filters],
          advanceFilters: [],
        };
      }
    }

    // if (data.field == "MENTIONS") {
    //   setinsightSelected("");
    // }
    setSelectedFilter(params);
    setPrevChartData([]);
    appLogger.info({
      infoObj: {
        method: "removeFilter",
        component: "feedback",
        fileName: "filter.tsx",
        data: { params, selectedFilter },
      },
    });

    // setTimeout(() => {

    applyFilter("", params, "");

    // }, 1000);

    if (params.filters.length == 0) {
      handleCloseAppliedFilter();
    }
  };

  const renderNoProductMessage = () => {
    let res = <></>;
    if (productResponse.length == 0 && !isLoading) {
      res = <NoProductMessage />;
    }
    return res;
  };

  useEffect(() => {
    const locState = location.state as {
      ratingsClicked?: { field: string };
      keyName?: string;
    } | null;
    if (
      selectedProVerDataType == "confirm" &&
      !locState?.ratingsClicked &&
      !locState?.keyName
    ) {
      setUserData([]);
      fetchFilteredData("");
      setSelectedFilter({ filters: [] });
      setAppliedFilter({});
      setPrevChartData([]);
      fetchCategoryChartData();
      fetchRatingChartData();

      setRender(false);
      setCategoryRender(false);

      setTimeout(() => {
        setRender(true);
        setCategoryRender(true);
      });

      if (enableInsights && enabledFeatures?.enableInsights) {
        fetchInsightsData();
      }
      setinsightSelected("");
    }
  }, [product, version, selectedProVerData, selectedProVerDataType]);

  const minDateTime = new Date();
  minDateTime.setHours(17);
  const maxDateTime = new Date();
  maxDateTime.setHours(20);

  const selectSentiment = (event: SelectChangeEvent<any[]>) => {
    const value = (event.target as HTMLInputElement).value;
    appLogger.info({
      infoObj: {
        method: "selectSentiment",
        component: "feedback",
        fileName: "filter.tsx",
        data: { value: value, selectedFilter: selectedFilter },
      },
    });
    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      if (
        temp &&
        temp.filters &&
        value.length > 0 &&
        temp.filters.find((data: any) => data.field === "SENTIMENT")
      ) {
        temp.filters.map((data: any) => {
          if (data.field === "SENTIMENT") {
            data.value = value;
          }
        });
        setSelectedFilter(temp);
      } else if (
        value.length === 0 &&
        temp.filters.find((data: any) => data.field === "SENTIMENT")
      ) {
        temp.filters = temp.filters.filter((data: any) => {
          return data.field !== "SENTIMENT";
        });
        setSelectedFilter(temp);
      } else {
        const ratingField = {
          field: "SENTIMENT",
          operation: "contains",
          value: value,
        };
        if (temp.filters) {
          temp.filters.push(ratingField);
        } else {
          temp.filters = [];
          temp.filters.push(ratingField);
        }
        setSelectedFilter(temp);
      }
    }
  };

  const selectEmail = (e: any, selectedData: any) => {
    const value = selectedData;
    appLogger.info({
      infoObj: {
        method: "selectEmail",
        component: "feedback",
        fileName: "filter.tsx",
        data: { value: value, selectedFilter: selectedFilter },
      },
    });

    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      if (
        temp &&
        temp.filters &&
        value.length > 0 &&
        temp.filters.find((data: any) => data.field === "EMAIL")
      ) {
        temp.filters.map((data: any) => {
          if (data.field === "EMAIL") {
            data.value = value;
          }
        });
        setSelectedFilter(temp);
      } else if (
        value.length === 0 &&
        temp.filters.find((data: any) => data.field === "EMAIL")
      ) {
        temp.filters = temp.filters.filter((data: any) => {
          return data.field !== "EMAIL";
        });
        setSelectedFilter(temp);
      } else {
        const ratingField = {
          field: "EMAIL",
          operation: "contains",
          value: value,
        };
        if (temp.filters) {
          temp.filters.push(ratingField);
        } else {
          temp.filters = [];
          temp.filters.push(ratingField);
        }
        setSelectedFilter(temp);
      }
    }
  };

  const selectAttachment = (event: SelectChangeEvent<any[]>) => {
    const value = (event.target as HTMLInputElement).value;
    appLogger.info({
      infoObj: {
        method: "selectAttachment",
        component: "feedback",
        fileName: "filter.tsx",
        data: { value: value, selectedFilter: selectedFilter },
      },
    });
    if (selectedFilter) {
      const temp: any = { ...selectedFilter };
      if (
        temp &&
        temp.filters &&
        value.length > 0 &&
        temp.filters.find((data: any) => data.field === "ATTACHMENT")
      ) {
        temp.filters.map((data: any) => {
          if (data.field === "ATTACHMENT") {
            data.value = value;
          }
        });
        setSelectedFilter(temp);
      } else if (
        value.length === 0 &&
        temp.filters.find((data: any) => data.field === "ATTACHMENT")
      ) {
        temp.filters = temp.filters.filter((data: any) => {
          return data.field !== "ATTACHMENT";
        });
        setSelectedFilter(temp);
      } else {
        const ratingField = {
          field: "ATTACHMENT",
          operation: "contains",
          value: value,
        };
        if (temp.filters) {
          temp.filters.push(ratingField);
        } else {
          temp.filters = [];
          temp.filters.push(ratingField);
        }
        setSelectedFilter(temp);
      }
    }
  };

  const handleDateFilter = () => {
    const filters = selectedFilter.filters;
    const startDate = filters.find(
      (data: { field: string }) => data.field === "START_DATE"
    );
    const endDate = filters.find(
      (data: { field: string }) => data.field === "END_DATE"
    );
    if (startDate && endDate && startDate.value < endDate.value) {
      return getDateString(endDate.value);
    }

    return "";
  };

  const findFilteredValue = (field: string): null | unknown => {
    const filterData = selectedFilter.filters.find(
      (data) => data.field === field
    );
    if (filterData) {
      return filterData.value;
    }

    return null;
  };

  return (
    <Grid className={isLoading ? " chart-item loader" : "chart-item"}>
      {renderNoProductMessage()}
      <Grid className="feedback-bug-filter" container sx={{ mb: 2 }}>
        <Grid
          xs={12}
          sm={12}
          md={12}
          lg={4}
          xl={4}
          className="pro-ver-dropdown-grid"
        >
          <ProductVersionDropdown
            productResponse={productResponse}
            selectedProVerData={selectedProVerData}
            selectedProVerDataFn={selectedProVerDataFn}
            contextProVersion={contextProVersion}
            type="cuvo-filter"
          />
        </Grid>

        <Grid item xs={6} sm={4} md={3} lg={2} sx={{ ml: "auto" }}>
          <Box>
            <FormControl className="custom-select search-input-field" fullWidth>
              <InputLabel>Search</InputLabel>
              <OutlinedInput
                title="Search is case-sensitive"
                type="text"
                value={search}
                onChange={handleSearchTyping}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleKeyPress(e);
                  }
                }}
                id="search-input"
                endAdornment={
                  <>
                    {search && (
                      <InputAdornment
                        id="search-clear"
                        position="end"
                        onClick={() => searchClear()}
                      >
                        <IconButton
                          aria-label="search icon"
                          edge="end"
                          className="search-fb-icon"
                        >
                          <CloseIcon className="cursor-pointer" />
                        </IconButton>
                      </InputAdornment>
                    )}
                    <InputAdornment
                      component="div"
                      id="search-icon"
                      position="end"
                      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                        search ? handleKeyPress(e) : searchClear();
                      }}
                    >
                      <IconButton
                        aria-label="search icon"
                        edge="end"
                        className="search-fb-icon"
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  </>
                }
                label="Search"
              />
            </FormControl>
          </Box>

          <Drawer
            className="advanced-filter-popup"
            anchor="right"
            open={open}
            onClose={handleDrawerOpen}
          >
            <Box sx={{ width: "100%" }}>
              <Box
                className="title-wrap"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderBottom: 1,
                  borderColor: "divider",
                }}
              >
                <Typography className="title">filter</Typography>
                <IconButton
                  className="close-filter"
                  style={{ fontSize: "1rem" }}
                  onClick={handleDrawerOpen}
                >
                  {/* <CloseIcon /> */}
                  <IconWithToolTip
                    message="Close Filter"
                    iconName="icon-close"
                  />
                </IconButton>
              </Box>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleTabChange}
                  aria-label="filter tabs"
                >
                  <Tab
                    value={0}
                    label={
                      selectedFilter && selectedFilter?.id
                        ? "edit filter"
                        : "create new filter"
                    }
                    {...a11yProps(0)}
                  />
                  <Tab value={1} label="saved filter" {...a11yProps(1)} />
                </Tabs>
              </Box>
              <TabPanel value={value} index={0}>
                <Grid item className="advanced-filter">
                  <Box>
                    <FormControl className="custom-select" fullWidth>
                      <InputLabel>Filter title</InputLabel>
                      <OutlinedInput
                        type="text"
                        value={
                          selectedFilter && selectedFilter.name
                            ? selectedFilter.name
                            : ""
                        }
                        onChange={handleFilterTitle}
                        id="filter-input"
                        label="Enter Title"
                      />
                    </FormControl>
                  </Box>
                  <Box className="filter-pro-version-section">
                    <InputLabel>Products & versions : </InputLabel>
                    <List
                      className="saved-list"
                      sx={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {contextProVersion && contextProVersion.length > 0
                        ? contextProVersion.map((fieldData: any) => (
                            <ListItem>
                              <ListItemText
                                primary={
                                  <Chip
                                    label={
                                      <>
                                        {fieldData.title +
                                          " - " +
                                          fieldData.version}
                                      </>
                                    }
                                  />
                                }
                              />
                            </ListItem>
                          ))
                        : ""}
                    </List>
                  </Box>

                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Box>
                        <TextField
                          className="date-picker custom-select"
                          id="datetime-local"
                          label="Start Date"
                          type="date"
                          value={
                            selectedFilter &&
                            selectedFilter.filters &&
                            selectedFilter.filters.find(
                              (data: any) => data.field === "START_DATE"
                            )
                              ? getDateString(findFilteredValue("START_DATE"))
                              : null
                          }
                          onChange={changeStartDateValue}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            step: 1,
                            max: currDate.toISOString().slice(0, 10),
                          }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box className="fb-to-datepicker">
                        <TextField
                          className="date-picker custom-select"
                          id="datetime-local"
                          label="End Date"
                          type="date"
                          value={handleDateFilter()}
                          onChange={changeEndDateValue}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            step: 1,
                            min:
                              selectedFilter &&
                              selectedFilter.filters &&
                              selectedFilter.filters.find(
                                (data: any) => data.field === "START_DATE"
                              )
                                ? getDateString(findFilteredValue("START_DATE"))
                                : null,
                            max: currDate.toISOString().slice(0, 10),
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    {pageType != "FEATURE_REQUEST" &&
                      (pageType == "FEEDBACK" ? (
                        <Grid item xs={12} md={6} id="ratings-select">
                          <FormControl
                            className="custom-select multiple"
                            fullWidth
                          >
                            <Autocomplete
                              id="free-solo-demo1"
                              onChange={selectFilterRating}
                              options={
                                ratingsData &&
                                ratingsData.map((e: any) => e.value)
                              }
                              multiple
                              value={
                                (findFilteredValue("RATINGS") as any[]) || []
                              }
                              renderInput={(ratingsData: any) => (
                                <TextField {...ratingsData} label="Ratings" />
                              )}
                            />
                          </FormControl>
                        </Grid>
                      ) : (
                        <Grid item xs={12} md={6} id="ratings-select">
                          <FormControl
                            className="custom-select multiple"
                            fullWidth
                          >
                            <Autocomplete
                              id="free-solo-demo2"
                              onChange={selectFilterRating}
                              options={
                                severityData && severityData.map((e: any) => e)
                              }
                              multiple
                              limitTags={2}
                              value={
                                (findFilteredValue("RATINGS") as any[]) || []
                              }
                              renderInput={(severityData: any) => (
                                <TextField {...severityData} label="Severity" />
                              )}
                            />
                          </FormControl>
                        </Grid>
                      ))}

                    <Grid item xs={12} md={6} id="email-select">
                      <FormControl className="custom-select multiple" fullWidth>
                        <Autocomplete
                          id="free-solo-demo3"
                          onChange={selectEmail}
                          options={
                            emailData &&
                            Object.keys(emailData).map((e: any) => e)
                          }
                          multiple
                          value={(findFilteredValue("EMAIL") as any[]) || []}
                          renderInput={(renderProps) => (
                            <TextField {...renderProps} label="Commenters" />
                          )}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6} id="category-select">
                      <FormControl className="custom-select multiple" fullWidth>
                        <Autocomplete
                          id="free-solo-demo4"
                          onChange={selectFilterCategory}
                          options={
                            CategoryData && CategoryData.map((e: any) => e)
                          }
                          multiple
                          value={(findFilteredValue("CATEGORY") as any[]) || []}
                          renderInput={(renderProps) => (
                            <TextField {...renderProps} label="Category" />
                          )}
                        />
                      </FormControl>

                      {/* <FormControl className="custom-select" fullWidth>
                        <InputLabel>Category</InputLabel>
                        <Select
                          labelId="category-select"
                          id="category-select"
                          value={
                            selectedFilter &&
                            selectedFilter.filters &&
                            selectedFilter.filters.find(
                              (data: any) => data.field === "CATEGORY"
                            )
                              ? selectedFilter.filters.find(
                                  (data: any) => data.field === "CATEGORY"
                                ).value
                              : []
                          }
                          onChange={selectFilterCategory}
                          label="severity"
                        >
                          {CategoryData &&
                            CategoryData.length > 0 &&
                            CategoryData.map((e: any) => (
                              <MenuItem value={e}>{e}</MenuItem>
                            ))}
                        </Select>
                      </FormControl> */}
                    </Grid>

                    {enableInsights && enabledFeatures?.enableInsights ? (
                      <Grid item xs={12} md={6} id="sentiment-select">
                        <FormControl
                          className="custom-select multiple"
                          fullWidth
                        >
                          <InputLabel>Sentiment</InputLabel>
                          <Select
                            labelId="sentiment-select"
                            id="sentiment-select"
                            value={
                              (findFilteredValue("SENTIMENT") as any[]) || []
                            }
                            renderValue={(selected: any) => (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {Array.isArray(selected) &&
                                  selected.map((e) => (
                                    <Chip key={e} label={e} />
                                  ))}
                              </Box>
                            )}
                            onChange={selectSentiment}
                            label="Sentiment"
                            multiple
                          >
                            <MenuItem value="POSITIVE">Positive</MenuItem>
                            <MenuItem value="NEGATIVE">Negative</MenuItem>
                            <MenuItem value="NEUTRAL">Neutral</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    ) : (
                      <></>
                    )}

                    <Grid item xs={12} md={6} id="attachment-select">
                      <FormControl className="custom-select multiple" fullWidth>
                        <InputLabel>Attachment</InputLabel>
                        <Select
                          labelId="attachment-select"
                          id="attachment-select"
                          value={
                            (findFilteredValue("ATTACHMENT") as any[]) || []
                          }
                          renderValue={(e: any) => (
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 0.5,
                              }}
                            >
                              {Array.isArray(e) &&
                                e.map((l) => <Chip key={l} label={l} />)}
                            </Box>
                          )}
                          onChange={selectAttachment}
                          label="Attachment"
                          multiple
                        >
                          <MenuItem value="audio">Audio</MenuItem>
                          <MenuItem value="file">File</MenuItem>
                          <MenuItem value="image">Image</MenuItem>
                          <MenuItem value="video">Video</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Box className="advance-filter-select-wrap">
                    <Grid
                      container
                      spacing={2}
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid item xs={12} md={6} id="advanced-filter-heading">
                        <Typography className="title">
                          advanced filter
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                        className="text-right"
                        id="advanced-filter-add"
                      >
                        <Button
                          variant="outlined"
                          onClick={handleAddCustomFilter}
                        >
                          <AddIcon />
                          Add Filter
                        </Button>
                      </Grid>
                    </Grid>
                    {selectedFilter &&
                    selectedFilter.advanceFilters &&
                    selectedFilter.advanceFilters.length > 0
                      ? selectedFilter.advanceFilters.map(
                          (filter: any, index: number) => (
                            <Grid
                              container
                              spacing={2}
                              sx={{ alignItems: "center" }}
                            >
                              <Grid item xs={12} md={3.6} id="attribute-select">
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>attribute</InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    value={
                                      filter && filter.field ? filter.field : ""
                                    }
                                    onChange={(event) =>
                                      selectCustomFilterAttribute(event, index)
                                    }
                                    id="attribute-select"
                                    label="attribute"
                                  />
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} md={3.6} id="condition-select">
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>condition</InputLabel>
                                  <Select
                                    labelId="condition-select"
                                    id="condition-select"
                                    value={
                                      filter && filter.operation
                                        ? filter.operation
                                        : ""
                                    }
                                    onChange={(event) =>
                                      selectCustomFilterCondition(event, index)
                                    }
                                    label="condition"
                                  >
                                    <MenuItem value="contains">
                                      contains
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>

                              <Grid item xs={12} md={3.6}>
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>Value</InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    value={
                                      filter && filter.value ? filter.value : ""
                                    }
                                    onChange={(event) =>
                                      selectCustomFilterValue(event, index)
                                    }
                                    id="filter-input"
                                    label="Enter Title"
                                  />
                                </FormControl>
                              </Grid>

                              <Grid
                                item
                                xs={12}
                                md={1.2}
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <CloseIcon
                                  className="cursor-pointer"
                                  onClick={() => removeAdvFilter(index)}
                                />
                              </Grid>
                            </Grid>
                          )
                        )
                      : ""}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    className="footer-action-btn"
                  >
                    <Button
                      variant="outlined"
                      onClick={() => {
                        handleDrawerOpen();
                        fetchFilterList();
                      }}
                    >
                      cancel
                    </Button>
                    {selectedFilter && selectedFilter.id ? (
                      <Button
                        variant="contained"
                        onClick={(event) => {
                          handleFilterSave(event, selectedFilter, "save");
                        }}
                      >
                        Save
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        onClick={(event) => {
                          handleFilterSave(event, selectedFilter, "apply");
                        }}
                      >
                        Apply
                      </Button>
                    )}
                  </Box>
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Box className="saved-list-wrap">
                  {filterResponse.length > 0 &&
                    filterResponse.map((filterData: any) => {
                      return (
                        <Box className="saved-list-item">
                          <Box className="saved-filters">
                            <Box
                              className="saved-header"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography component="h3">
                                {filterData && filterData.name
                                  ? filterData.name
                                  : ""}
                              </Typography>
                              <Box className="filter-edit-btns">
                                <Button
                                  variant="text"
                                  style={{ marginRight: "5px" }}
                                  onClick={() => handlefilterEdit(filterData)}
                                >
                                  <IconWithToolTip
                                    message="Edit Filter"
                                    iconName="icon-edit"
                                  />
                                </Button>
                                <Button variant="text">
                                  <IconWithToolTip
                                    message="Delete Filter"
                                    iconName="icon-delete"
                                    handleClick={() =>
                                      handleFilterDelete(event, filterData)
                                    }
                                  />
                                </Button>
                              </Box>
                            </Box>
                            <List
                              className="saved-list"
                              sx={{ display: "flex", flexWrap: "wrap" }}
                            >
                              {filterData &&
                              filterData.filters &&
                              filterData.filters.length > 0
                                ? filterData?.filters?.map((fieldData: any) => {
                                    if (fieldData.field === "RATINGS") {
                                      // return fieldData.value ? (
                                      //   <ListItem>
                                      //     <ListItemText
                                      //       primary={
                                      //         <Chip
                                      //           label={
                                      //             <>
                                      //               <AutoGraphIcon className="appliedfilter-i-icon" />
                                      //               {Number.isInteger(
                                      //                 parseInt(fieldData.value)
                                      //               ) ? (
                                      //                 <Rating
                                      //                   className="ratings"
                                      //                   name="read-only"
                                      //                   value={
                                      //                     fieldData &&
                                      //                     fieldData.value
                                      //                       ? fieldData.value
                                      //                       : 0
                                      //                   }
                                      //                   readOnly
                                      //                 />
                                      //               ) : (
                                      //                 fieldData.value
                                      //               )}
                                      //             </>
                                      //           }
                                      //         />
                                      //       }
                                      //     />
                                      //   </ListItem>
                                      // ) : (
                                      //   ""
                                      // );

                                      return fieldData
                                        ? fieldData?.value?.map((e: any) => {
                                            return (
                                              <ListItem>
                                                <ListItemText
                                                  primary={
                                                    <Chip
                                                      label={
                                                        <>
                                                          <AutoGraphIcon className="appliedfilter-i-icon" />
                                                          {Number.isInteger(
                                                            parseInt(
                                                              fieldData.value
                                                            )
                                                          ) ? (
                                                            <Rating
                                                              className="ratings"
                                                              name="read-only"
                                                              value={
                                                                fieldData &&
                                                                fieldData.value
                                                                  ? e
                                                                  : 0
                                                              }
                                                              readOnly
                                                            />
                                                          ) : (
                                                            e
                                                          )}
                                                        </>
                                                      }
                                                    />
                                                  }
                                                />
                                              </ListItem>
                                            );
                                          })
                                        : "";
                                    }
                                    if (fieldData.field === "PRODUCT_ID") {
                                      if (
                                        productResponse &&
                                        productResponse.length > 0
                                      ) {
                                        let list: any = "";
                                        productResponse.map((menu: any) => {
                                          if (menu.id === fieldData.value)
                                            list = (
                                              <ListItem>
                                                <ListItemText
                                                  primary={
                                                    <Chip label={menu.name} />
                                                  }
                                                />
                                              </ListItem>
                                            );
                                        });
                                        return list;
                                      }
                                      return (
                                        <ListItem>
                                          <ListItemText
                                            primary={
                                              <Chip label="no product found" />
                                            }
                                          />
                                        </ListItem>
                                      );
                                    }
                                    if (fieldData.field === "START_DATE") {
                                      const startDateData =
                                        "Start : " +
                                        getDateTime(
                                          parseInt(fieldData.value, 10)
                                        );
                                      return fieldData.value ? (
                                        <ListItem>
                                          <ListItemText
                                            primary={
                                              <Chip
                                                label={
                                                  <>
                                                    <CalendarMonthIcon className="appliedfilter-i-icon" />
                                                    {startDateData.toString()}
                                                  </>
                                                }
                                              />
                                            }
                                          />
                                        </ListItem>
                                      ) : (
                                        ""
                                      );
                                    }
                                    if (fieldData.field === "END_DATE") {
                                      const endDateData =
                                        "End : " +
                                        getDateTime(
                                          parseInt(fieldData.value, 10)
                                        );
                                      return fieldData.value ? (
                                        <ListItem>
                                          <ListItemText
                                            primary={
                                              <Chip
                                                label={
                                                  <>
                                                    <CalendarMonthIcon className="appliedfilter-i-icon" />
                                                    {endDateData.toString()}
                                                  </>
                                                }
                                              />
                                            }
                                          />
                                        </ListItem>
                                      ) : (
                                        ""
                                      );
                                    }

                                    if (fieldData.field === "EMAIL") {
                                      const email = fieldData.value;
                                      return fieldData.value ? (
                                        <ListItem>
                                          <ListItemText
                                            primary={
                                              <Chip
                                                label={
                                                  <>
                                                    <EmailIcon className="appliedfilter-i-icon" />
                                                    {email}
                                                  </>
                                                }
                                              />
                                            }
                                          />
                                        </ListItem>
                                      ) : (
                                        ""
                                      );
                                    }

                                    if (fieldData.field === "PRODUCT_VERSION") {
                                      const versionData =
                                        "Version - " + fieldData.value;
                                      return fieldData.value ? (
                                        <ListItem>
                                          <ListItemText
                                            primary={
                                              <Chip label={versionData} />
                                            }
                                          />
                                        </ListItem>
                                      ) : (
                                        ""
                                      );
                                    }
                                    if (fieldData.field === "MENTIONS") {
                                      const versionData =
                                        "Mentions : " + fieldData.value;
                                      return fieldData.value ? (
                                        <ListItem>
                                          <ListItemText
                                            primary={
                                              <Chip
                                                label={
                                                  <>
                                                    <PersonIcon className="appliedfilter-i-icon" />
                                                    {versionData.toString()}
                                                  </>
                                                }
                                              />
                                            }
                                          />
                                        </ListItem>
                                      ) : (
                                        ""
                                      );
                                    }
                                    if (fieldData.field === "CATEGORY") {
                                      const catData =
                                        "Category : " + fieldData.value;
                                      return fieldData.value ? (
                                        <ListItem>
                                          <ListItemText
                                            primary={
                                              <Chip
                                                label={
                                                  <>
                                                    <CategoryIcon className="appliedfilter-i-icon" />
                                                    {catData.toString()}
                                                  </>
                                                }
                                              />
                                            }
                                          />
                                        </ListItem>
                                      ) : (
                                        ""
                                      );
                                    }
                                    return fieldData.value ? (
                                      <ListItem>
                                        <ListItemText
                                          primary={
                                            <Chip label={fieldData.value} />
                                          }
                                        />
                                      </ListItem>
                                    ) : (
                                      ""
                                    );
                                  })
                                : ""}

                              {filterData &&
                              filterData.advanceFilters &&
                              filterData.advanceFilters.length > 0
                                ? filterData.advanceFilters.map(
                                    (fieldData: any) => {
                                      return fieldData.value ? (
                                        <ListItem>
                                          <ListItemText
                                            primary={
                                              <Chip
                                                label={
                                                  <>
                                                    <FilterAltIcon className="appliedfilter-i-icon" />
                                                    <span>
                                                      {humanize(
                                                        fieldData.field
                                                      )}
                                                    </span>
                                                    {" " +
                                                      fieldData.operation +
                                                      " " +
                                                      fieldData.value}
                                                  </>
                                                }
                                              />
                                            }
                                          />
                                        </ListItem>
                                      ) : (
                                        ""
                                      );
                                    }
                                  )
                                : ""}
                            </List>
                          </Box>

                          <Box className="apply-link">
                            <Button variant="outlined">
                              <Typography
                                onClick={(event) =>
                                  applyFilter(event, filterData, "apply")
                                }
                              >
                                apply
                              </Typography>
                            </Button>
                          </Box>
                        </Box>
                      );
                    })}
                </Box>
              </TabPanel>
            </Box>
          </Drawer>
        </Grid>

        <Grid item xs={6} sm={4} md={3} lg={2} sx={{ ml: "10px" }}>
          <Box>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>Filter</InputLabel>
              <Select
                labelId="filter-select"
                id="filter-select"
                value={
                  appliedFilter && Object.keys(appliedFilter).length > 0
                    ? appliedFilter.id
                    : ""
                }
                label="Filter"
                onChange={selectFilter}
              >
                <MenuItem
                  value={0}
                  onClick={() => {
                    handleDrawerOpen();
                    handleTabChange("", 0);
                    handleSelectFilter({
                      name: "",
                      filters: [],
                      advanceFilters: [],
                    });
                  }}
                >
                  <>Create / manage</>
                </MenuItem>

                <Divider />
                <Typography className="dropmenu-label">
                  saved filters
                </Typography>
                {filterResponse.length > 0 &&
                  filterResponse.map((filter: any) => {
                    return (
                      <MenuItem
                        onClick={(event: any) => {
                          applyFilter(event, filter, "saved"),
                            handleSelectFilter(filter);
                          searchClear();
                          setUserData([]);
                        }}
                        key={filter.id}
                        value={filter.id}
                      >
                        {filter.name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Box>
        </Grid>
      </Grid>
      {SavedFilterSuccessToaster && (
        <Box className="filter-selected">
          Filter saved successfully <b>Go to Filter &gt; Saved Filters</b> to
          apply and manage it.
        </Box>
      )}
      {
        appliedFilter &&
          Object.keys(appliedFilter).length > 0 &&
          appliedFilter.filters.length > 0 && (
            // (!insightSelected ||
            //   appliedFilter.filters.length > 0 ||
            //   (insightSelected && TempInsightFlag) ||
            //   (!insightSelected && !TempInsightFlag)) ? (

            <Box
              className="filter-selected"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography
                  className="label"
                  component="label"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  Filtered by:
                  {selectedFilter && selectedFilter?.id && (
                    <Typography>{appliedFilter.name}</Typography>
                  )}
                </Typography>
                <List
                  className="saved-list"
                  sx={{ display: "flex", flexWrap: "wrap" }}
                >
                  {appliedFilter &&
                  appliedFilter.filters &&
                  appliedFilter.filters.length > 0
                    ? appliedFilter.filters
                        // .filter((n: any) => n.field != "MENTIONS")
                        .map((fieldData: any) => {
                          if (fieldData.field === "RATINGS") {
                            const rating = fieldData.value;
                            appLogger.info({
                              infoObj: {
                                method: "insideReturn",
                                component: "feedback",
                                fileName: "filter.tsx",
                                ratingFieldData: fieldData.value,
                              },
                            });
                            return rating
                              ? rating?.map((e: any) => {
                                  return (
                                    <ListItem>
                                      <ListItemText
                                        primary={
                                          <Chip
                                            label={
                                              <>
                                                <AutoGraphIcon className="appliedfilter-i-icon" />
                                                {Number.isInteger(
                                                  parseInt(fieldData.value)
                                                ) ? (
                                                  <Rating
                                                    className="ratings"
                                                    name="read-only"
                                                    value={
                                                      fieldData &&
                                                      fieldData.value
                                                        ? e
                                                        : 0
                                                    }
                                                    readOnly
                                                  />
                                                ) : (
                                                  e
                                                )}
                                                <IconWithToolTip
                                                  message="remove"
                                                  iconName="icon-close"
                                                  handleClick={() => {
                                                    fieldData.value =
                                                      fieldData.value.filter(
                                                        (data: any) => {
                                                          return data !== e;
                                                        }
                                                      );

                                                    removeFilter(fieldData);
                                                  }}
                                                  readOnly
                                                />
                                              </>
                                            }
                                          />
                                        }
                                      />
                                    </ListItem>
                                  );
                                })
                              : "";
                          }

                          if (fieldData.field === "PRODUCT_ID") {
                            if (productResponse && productResponse.length > 0) {
                              let list: any = "";
                              productResponse.map((menu: any) => {
                                if (menu.id === fieldData.value)
                                  list = (
                                    <ListItem>
                                      <ListItemText
                                        primary={<Chip label={menu.name} />}
                                      />
                                    </ListItem>
                                  );
                              });
                              return list;
                            }
                            return (
                              <ListItem>
                                <ListItemText
                                  primary={<Chip label="no product found" />}
                                />
                              </ListItem>
                            );
                          }
                          if (fieldData.field === "START_DATE") {
                            const startDateData =
                              "Start : " + getDateString(fieldData.value);
                            // getDateTime(parseInt(fieldData.value, 10));
                            return fieldData.value ? (
                              <ListItem>
                                <ListItemText
                                  primary={
                                    <Chip
                                      label={
                                        <>
                                          <CalendarMonthIcon className="appliedfilter-i-icon" />
                                          {startDateData.toString()}
                                          <IconWithToolTip
                                            message="remove"
                                            iconName="icon-close"
                                            handleClick={() =>
                                              removeFilter(fieldData)
                                            }
                                          />
                                        </>
                                      }
                                    />
                                  }
                                />
                              </ListItem>
                            ) : (
                              ""
                            );
                          }
                          if (fieldData.field === "END_DATE") {
                            const endDateData =
                              "End : " + getDateString(fieldData.value);

                            // getDateTime(parseInt(fieldData.value, 10));
                            return fieldData.value ? (
                              <ListItem>
                                <ListItemText
                                  primary={
                                    <Chip
                                      label={
                                        <>
                                          <CalendarMonthIcon className="appliedfilter-i-icon" />
                                          {endDateData.toString()}
                                          <IconWithToolTip
                                            message="remove"
                                            iconName="icon-close"
                                            handleClick={() =>
                                              removeFilter(fieldData)
                                            }
                                          />
                                        </>
                                      }
                                    />
                                  }
                                />
                              </ListItem>
                            ) : (
                              ""
                            );
                          }
                          if (fieldData.field === "EMAIL") {
                            const email = fieldData.value;
                            appLogger.info({
                              infoObj: {
                                method: "insideReturn",
                                component: "feedback",
                                fileName: "filter.tsx",
                                email: email,
                              },
                            });
                            return email
                              ? email?.map((e: any) => {
                                  return (
                                    <ListItem>
                                      <ListItemText
                                        primary={
                                          <Chip
                                            label={
                                              <>
                                                <EmailIcon className="appliedfilter-i-icon" />
                                                {e}
                                                <IconWithToolTip
                                                  message="remove"
                                                  iconName="icon-close"
                                                  handleClick={() => {
                                                    fieldData.value =
                                                      fieldData.value.filter(
                                                        (data: any) => {
                                                          return data !== e;
                                                        }
                                                      );

                                                    removeFilter(fieldData);
                                                  }}
                                                />
                                              </>
                                            }
                                          />
                                        }
                                      />
                                    </ListItem>
                                  );
                                })
                              : "";
                          }
                          if (fieldData.field === "ATTACHMENT") {
                            const attachment = fieldData.value;
                            appLogger.info({
                              infoObj: {
                                method: "insideReturn",
                                component: "feedback",
                                fileName: "filter.tsx",
                                attachment: attachment,
                              },
                            });
                            return attachment
                              ? attachment.map((e: any) => {
                                  return (
                                    <ListItem>
                                      <ListItemText
                                        primary={
                                          <Chip
                                            label={
                                              <>
                                                <AttachFileIcon className="appliedfilter-i-icon" />
                                                {e}
                                                <IconWithToolTip
                                                  message="remove"
                                                  iconName="icon-close"
                                                  handleClick={() => {
                                                    fieldData.value =
                                                      fieldData.value.filter(
                                                        (data: any) => {
                                                          return data !== e;
                                                        }
                                                      );

                                                    removeFilter(fieldData);
                                                  }}
                                                />
                                              </>
                                            }
                                          />
                                        }
                                      />
                                    </ListItem>
                                  );
                                })
                              : "";
                          }
                          if (fieldData.field === "SENTIMENT") {
                            const sentiment = fieldData.value;
                            appLogger.info({
                              infoObj: {
                                method: "insideReturn",
                                component: "feedback",
                                fileName: "filter.tsx",
                                sentiment: sentiment,
                              },
                            });
                            return sentiment
                              ? sentiment.map((e: any) => {
                                  return (
                                    <ListItem>
                                      <ListItemText
                                        primary={
                                          <Chip
                                            label={
                                              <>
                                                <InsightsIcon className="appliedfilter-i-icon" />
                                                {e}
                                                <IconWithToolTip
                                                  message="remove"
                                                  iconName="icon-close"
                                                  handleClick={() => {
                                                    fieldData.value =
                                                      fieldData.value.filter(
                                                        (data: any) => {
                                                          return data !== e;
                                                        }
                                                      );

                                                    removeFilter(fieldData);
                                                  }}
                                                />
                                              </>
                                            }
                                          />
                                        }
                                      />
                                    </ListItem>
                                  );
                                })
                              : "";
                          }
                          if (fieldData.field === "MENTIONS") {
                            const sentiment = fieldData.value;
                            appLogger.info({
                              infoObj: {
                                method: "insideReturn",
                                component: "feedback",
                                fileName: "filter.tsx",
                                mentions: sentiment,
                              },
                            });
                            return sentiment
                              ? sentiment.map((e: any) => {
                                  return (
                                    <ListItem>
                                      <ListItemText
                                        primary={
                                          <Chip
                                            label={
                                              <>
                                                <InsightsIcon className="appliedfilter-i-icon" />
                                                {e}
                                                <IconWithToolTip
                                                  message="remove"
                                                  iconName="icon-close"
                                                  handleClick={() => {
                                                    fieldData.value =
                                                      fieldData.value.filter(
                                                        (data: any) => {
                                                          return data !== e;
                                                        }
                                                      );

                                                    removeFilter(fieldData);
                                                  }}
                                                />
                                              </>
                                            }
                                          />
                                        }
                                      />
                                    </ListItem>
                                  );
                                })
                              : "";
                          }
                          if (fieldData.field === "PRODUCT_VERSION") {
                            const versionData = "Version - " + fieldData.value;
                            return fieldData.value ? (
                              <ListItem>
                                <ListItemText
                                  primary={<Chip label={versionData} />}
                                />
                              </ListItem>
                            ) : (
                              ""
                            );
                          }

                          if (fieldData.field === "CATEGORY") {
                            const category = fieldData.value;
                            appLogger.info({
                              infoObj: {
                                method: "insideReturn",
                                component: "feedback",
                                fileName: "filter.tsx",
                                category: category,
                              },
                            });
                            return category
                              ? category.map((e: any) => {
                                  return (
                                    <ListItem>
                                      <ListItemText
                                        primary={
                                          <Chip
                                            label={
                                              <>
                                                <CategoryIcon className="appliedfilter-i-icon" />
                                                {e?.toString()}
                                                <IconWithToolTip
                                                  message="remove"
                                                  iconName="icon-close"
                                                  handleClick={() => {
                                                    fieldData.value =
                                                      fieldData.value.filter(
                                                        (data: any) => {
                                                          return data !== e;
                                                        }
                                                      );

                                                    removeFilter(fieldData);
                                                  }}
                                                />
                                              </>
                                            }
                                          />
                                        }
                                      />
                                    </ListItem>
                                  );
                                })
                              : "";
                          }

                          // if (fieldData.field === "CATEGORY") {
                          //   const catData = "Category : " + fieldData.value;
                          //   return fieldData.value ? (
                          //     <ListItem>
                          //       <ListItemText
                          //         primary={
                          //           <Chip
                          //             label={
                          //               <>
                          //                 <CategoryIcon className="appliedfilter-i-icon" />
                          //                 {catData.toString()}
                          //                 <IconWithToolTip
                          //                   message="remove"
                          //                   iconName="icon-close"
                          //                   handleClick={() =>
                          //                     removeFilter(fieldData)
                          //                   }
                          //                 />
                          //               </>
                          //             }
                          //           />
                          //         }
                          //       />
                          //     </ListItem>
                          //   ) : (
                          //     ""
                          //   );
                          // }

                          return fieldData.value ? (
                            <ListItem>
                              <ListItemText
                                primary={<Chip label={fieldData.value} />}
                              />
                            </ListItem>
                          ) : (
                            ""
                          );
                        })
                    : ""}
                  {appliedFilter &&
                  appliedFilter.advanceFilters &&
                  appliedFilter.advanceFilters.length > 0
                    ? appliedFilter.advanceFilters.map((fieldData: any) => {
                        return fieldData.value ? (
                          <ListItem>
                            <ListItemText
                              primary={
                                <Chip
                                  label={
                                    <>
                                      <FilterAltIcon className="appliedfilter-i-icon" />
                                      <span>{humanize(fieldData.field)}</span>
                                      {" " +
                                        fieldData.operation +
                                        " " +
                                        fieldData.value}
                                      <IconWithToolTip
                                        message="remove"
                                        iconName="icon-close"
                                        handleClick={() =>
                                          removeFilter(fieldData)
                                        }
                                      />
                                    </>
                                  }
                                />
                              }
                            />
                          </ListItem>
                        ) : (
                          ""
                        );
                      })
                    : ""}
                  {appliedFilter &&
                  appliedFilter.advanceFilters &&
                  appliedFilter.advanceFilters.length > 0
                    ? appliedFilter.advanceFilters.map((fieldData: any) => {
                        return fieldData.value ? (
                          <ListItem>
                            <ListItemText
                              primary={
                                <Chip
                                  label={
                                    <>
                                      <FilterAltIcon className="appliedfilter-i-icon" />
                                      <span>{humanize(fieldData.field)}</span>
                                      {" " +
                                        fieldData.operation +
                                        " " +
                                        fieldData.value}
                                      <IconWithToolTip
                                        message="remove"
                                        iconName="icon-close"
                                        handleClick={() =>
                                          removeFilter(fieldData)
                                        }
                                      />
                                    </>
                                  }
                                />
                              }
                            />
                          </ListItem>
                        ) : (
                          ""
                        );
                      })
                    : ""}
                </List>
              </Box>
              <Box className="filter-edit-btns">
                {showSaveFilterBtn && (
                  <Chip
                    className="save-filter-chip"
                    variant="outlined"
                    label={
                      <>
                        <Box className="save-filter-box" />
                        {selectedFilter?.name && (
                          <span className="save-filter-name">
                            {selectedFilter.name}
                          </span>
                        )}

                        <span
                          id="save-filter"
                          className="save-filter"
                          onClick={(event) => {
                            {
                              selectedFilter?.name &&
                                handleFilterSave(event, selectedFilter, "save");
                            }
                            {
                              !selectedFilter?.name &&
                                handleFilterEditClicked(appliedFilter);
                            }
                          }}
                        >
                          &nbsp;Save this filter
                        </span>
                      </>
                    }
                  />
                )}
                <Button
                  variant="text"
                  onClick={() => {
                    handleCloseAppliedFilter();
                  }}
                >
                  <IconWithToolTip
                    message="Close Filter"
                    iconName="icon-close"
                  />
                </Button>
                <Button>
                  {/* <EditIcon
                onClick={ () => handleFilterEditClicked(appliedFilter)}
              /> */}
                  <IconWithToolTip
                    message="Edit Filter"
                    iconName="icon-edit"
                    handleClick={() => handleFilterEditClicked(appliedFilter)}
                  />
                </Button>
              </Box>
            </Box>
          )

        // ) : (
        //   ""
        // )
      }
      <Box
        sx={{
          mt: 2,
          background: "#0157ff1a",
          color: "#585656",
          fontSize: "13px",
          p: 1,
          border: "1px solid #0157ff40",
          borderRadius: "8px",
        }}
      >
        <span>
          Total Count :{" "}
          <b>
            {pageType == "FEATURE_REQUEST"
              ? categoryChartData
                ? categoryChartData.total
                  ? categoryChartData.total
                  : 0
                : 0
              : TotalFbRatingChartData}
          </b>
        </span>
        <span style={{ color: "#969393" }}> | </span>
        <span>
          Filtered Count :
          <b>
            {" "}
            {appliedFilter?.filters?.length ? (
              pageType == "BUG_REPORT" ? (
                bugChartData ? (
                  bugChartData.total ? (
                    filteredTotal
                  ) : (
                    0
                  )
                ) : (
                  0
                )
              ) : pageType == "FEATURE_REQUEST" ? (
                categoryChartData ? (
                  categoryChartData.total ? (
                    filteredTotal
                  ) : (
                    0
                  )
                ) : (
                  0
                )
              ) : categoryChartData ? (
                categoryChartData.total ? (
                  filteredTotal
                ) : (
                  0
                )
              ) : (
                0
              )
            ) : (
              <span>
                NA{" "}
                <span
                  style={{
                    color: "#0504048c",
                    fontWeight: "500",
                    fontSize: "10px",
                  }}
                >
                  (filter not applied)
                </span>
              </span>
            )}
          </b>
        </span>
      </Box>

      <Grid
        className={
          appliedFilter?.filters?.length === 1 &&
          appliedFilter?.filters[0]?.field === "RATINGS"
            ? "chart-wrap rating-select"
            : appliedFilter?.filters?.length === 1 &&
              appliedFilter?.filters[0]?.field === "CATEGORY"
            ? "chart-wrap category-select"
            : appliedFilter?.filters?.length > 1 &&
              appliedFilter?.filters?.find((e: any) => e.field === "RATINGS") &&
              appliedFilter?.filters?.find((e: any) => e.field === "CATEGORY")
            ? "chart-wrap rating-category-selected"
            : "chart-wrap"
        }
        container
        spacing={2}
      >
        {pageType != "FEATURE_REQUEST" ? (
          <Grid item xs={12} lg={6}>
            <Box className="chart-item ratings-chart">
              <h2 className="title">
                {pageType == "BUG_REPORT" ? "Severity" : "Ratings"}
              </h2>

              <Box className="avg-rating">
                {pageType == "FEEDBACK" && (
                  <>
                    <Rating
                      className="ratings"
                      name="read-only"
                      value={
                        ratingChartData
                          ? ratingChartData.avg
                            ? ratingChartData.avg
                            : 0
                          : 0
                      }
                      readOnly
                    />
                    <Typography>
                      {ratingChartData
                        ? ratingChartData.avg
                          ? ratingChartData.avg
                          : 0
                        : 0}{" "}
                      out of 5 <span>(Average rating)</span>
                    </Typography>{" "}
                  </>
                )}
              </Box>
              {pageType == "BUG_REPORT" && (
                <>
                  {render && (
                    <DashBugReportchart
                      bugReportChartData={bugChartData}
                      setChartData={setChartData}
                      chartShow={chartShow}
                      filter={appliedFilter}
                      selected={selectedFilter}
                    />
                  )}
                </>
              )}
              {pageType == "FEEDBACK" && (
                <>
                  {render && (
                    <RatingChart
                      ratingChartData={ratingChartData}
                      setChartData={setChartData}
                      chartShow={chartShow}
                      filter={appliedFilter}
                      selected={selectedFilter}
                    />
                  )}
                </>
              )}
            </Box>
          </Grid>
        ) : (
          <></>
        )}
        <Grid item xs={12} lg={6}>
          <Box className="chart-item category-chart">
            <h2 className="title">Reported on Category</h2>
            {categoryRender && (
              <CategoryChart
                categoryChartData={categoryChartData}
                setChartData={setChartData}
                chartShow={chartShow}
                filter={appliedFilter}
                selected={selectedFilter}
              />
            )}
          </Box>
        </Grid>
      </Grid>
      <Reports
        isFetching={isFetching}
        userData={userData}
        fetchMoreUserData={fetchMoreUserData}
        filterLastEvaluatedKey={filterLastEvaluatedKey}
        getSignedUrl={getSignedUrl}
        pageType={pageType}
        product={product}
        version={version}
        filterUrlData={filterUrlData}
        addFilterUrlData={addFilterUrlData}
        searchKeyword={searchKeyword}
        insightsData={insightsData}
        insightSelected={insightSelected}
        chipFilter={chipFilter}
        contextProVersion={contextProVersion}
        proVerUrl={proVerUrl}
        setChartData={setChartData}
      />
    </Grid>
  );
}

export default withSnackbar(Filter);
